'use client'

import { IconPlusLarge } from 'icons/components/IconPlusLarge'
import Image, { type ImageProps } from 'next/image'
import CustomCursor from 'utils/CustomCursor/CustomCursor'
import { cx } from 'utils/cx'

import { useAnalytics } from '../../../contexts/AnalyticsProvider/AnalyticsProvider'
import type { Media } from '../../../types/FullProduct'
import { PdpActionEvents } from '../../../types/PdpActionEvents'
import { useZoom } from './contexts/useZoom'

import styles from './Zoom.module.scss'

type ZoomImageItem = Omit<ImageProps, 'src' | 'alt'> & {
	readonly label?: string
	readonly media: Media
	readonly dataTestid?: string
}

export function ZoomImageItem({
	media,
	dataTestid,
	className,
	label,
	...imageProps
}: ZoomImageItem): React.ReactNode {
	const { alt, src } = media
	const { select } = useZoom()
	const { sendPdpActionEvent } = useAnalytics()

	const handleClick = (): void => {
		select(media)
		sendPdpActionEvent(PdpActionEvents.ZOOM_OPEN)
	}

	return (
		<CustomCursor
			cursorContent={
				<div className={styles.customCursorCotainer}>
					<IconPlusLarge />
				</div>
			}
		>
			<button
				lang='en'
				aria-label={label}
				className={cx(styles.imageItemButton)}
				data-testid={dataTestid}
				onClick={handleClick}
			>
				<Image className={cx(className)} {...imageProps} alt={alt} src={src} />
			</button>
		</CustomCursor>
	)
}
